import React, { useCallback } from 'react'
import styled from '@emotion/styled'
import { css } from '@emotion/core'
import { Paragraph1 } from 'components/Paragraphs'

const Container = styled.div`
  display: flex;
  align-items: center;
`
const Label = styled(Paragraph1)(({ theme, isDisabled }) => css`
  color: ${theme.blueElectric};
  transition: opacity 150ms cubic-bezier(0.86,0,0.07,1);
  opacity: ${isDisabled ? 0.2 : 1};
  cursor: pointer;
`)

const Button = styled.div(({ isChecked, theme, height }) => css`
  background: ${theme.blueElectricLighter};
  position: relative;
  width: ${height * 2}px;
  height: ${height}px;
  border-radius: ${height}px;
  cursor: pointer;
  margin: 0 10px;
  :after {
    content: '';
    position: absolute;
    left: ${isChecked ? `calc(100% - ${height}px)` : '0%'};
    top: 0;
    transition: left 150ms cubic-bezier(0.86,0,0.07,1);
    width: ${height}px;
    height: ${height}px;
    border-radius: ${height}px;
    display: block;
    background: ${theme.blueElectric};
  }
`)

const ToggleSwitch = ({
  labels = ['', ''],
  onChange = () => { },
  isChecked = false,
  height = 24
}) => {
  const onOff = useCallback(
    (e) => {
      onChange(false)
    },
    [onChange]
  )
  const onOn = useCallback(
    (e) => {
      onChange(true)
    },
    [onChange]
  )
  const onToggle = useCallback(
    (e) => onChange(!isChecked),
    [isChecked, onChange]
  )

  return (
    <Container>
      <Label isDisabled={isChecked} onClick={onOff}>
        {labels[0]}
      </Label>
      <Button
        isChecked={isChecked}
        height={height}
        onClick={onToggle}
      />
      <Label isDisabled={!isChecked} onClick={onOn}>
        {labels[1]}
      </Label>
    </Container>
  )
}

export default ToggleSwitch
